var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7712 34.7889L24.0003 23.9997M29.417 14.6178C24.7444 11.92 18.8974 13.0988 15.6002 17.1562C15.2783 17.5522 15.1174 17.7502 15.0706 18.0339C15.0334 18.2597 15.0885 18.5588 15.2039 18.7564C15.3488 19.0047 15.6057 19.1531 16.1195 19.4497L31.8812 28.5497C32.395 28.8463 32.6519 28.9947 32.9394 28.996C33.1682 28.9971 33.4548 28.8953 33.6317 28.7502C33.854 28.5678 33.945 28.3294 34.127 27.8527C35.9922 22.9685 34.0896 17.3155 29.417 14.6178ZM29.417 14.6178C27.3444 13.4211 23.2391 16.6515 20.2475 21.833M29.417 14.6178C31.4896 15.8144 30.7446 20.9849 27.7531 26.1664M34.8337 34.833H13.167",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedicon);
export default __webpack_public_path__ + "static/media/Featured icon.b138fa760f4fbb1f2715f0a92aca3720.svg";
export { ForwardRef as ReactComponent };